/**
 * Created with IntelliJ IDEA.
 * User: orenm
 * Date: 12/9/14
 * Time: 7:40 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var CP_CONST = require("connection-const");
    var RecentSnippetsCollection = require("connection-collections/KPsTab/RecentSnippetsCollection");
    var KPsSnippetsCompositeView = require("connection-views/KPsTab/KPsSnippetsCompositeView");
    var KPsSnippetsCompositeModel = require("connection-models/KPsTab/KPsSnippetsCompositeModel");

    var RecentSnippetsController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        RecentSnippetsController = Marionette.Controller.extend({
            referrerActionsArr: [
                CP_CONST.REFERER_ACTION.RECENT_SNIPPET,
                CP_CONST.REFERER_ACTION.DIRECT_LINK_TO_CONTENT,
                CP_CONST.REFERER_ACTION.CLICK_TO_CONTENT,
                CP_CONST.REFERER_ACTION.REFRESH,
                CP_CONST.REFERER_ACTION.RELATED_SNIPPET
            ],
            referrerAction: CP_CONST.REFERER_ACTION.RECENT_SNIPPET,

            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.selectedKP = this.connectionPanelContextModel.get("selectedKP");
                this._setupRecent();
                this._setEventListeners();
            },

            _setEventListeners: function () {
                this.listenTo(LEConnection.vent, "recentSnippetsCollection:fetch:success", this._updateRecentCollection);
                this.listenTo(this.connectionPanelContextModel, "change:selectedKP", this._onSelectedKPChange, this);
            },

            _setupRecent: function () {
                this.recentSnippetsCollection = this._getRecentSnippetsCollection();

                var isAuthenticatedUser = this._isAuthenticatedUser();
                if (isAuthenticatedUser) {
                    this._performFetchWithAuth();
                }
                else {
                    this.performFetchWithoutAuth();
                }
            },

            _onSuccess: function (collection) {
                LEConnection.logger.debug("RecentSnippetsController:_fetchSnippets - success");
                this._showRecent();
            },

            _onError: function (options) {
                LEConnection.logger.error("KPsSearchController:_fetchRecent - Failed to fetch data");
                this._getRecentSnippetsCollection().reset();
                this._hideSnippetCompositeView();
                // TODO display error
            },

            _getRecentSnippetsCollection: function () {
                if (!this.recentSnippetsCollection) {
                    this.recentSnippetsCollection = new RecentSnippetsCollection();
                }
                return this.recentSnippetsCollection;
            },

            _updateRecentCollection: function () {

                var selectedKP = this.connectionPanelContextModel.get("selectedKP");

                if (selectedKP) {
                    this.recentSnippetsCollection.updateCollection(selectedKP);
                    this._showRecent();
                    this._reRenderViewIfNeeded();
                }
                this._setSelected(selectedKP);
            },

            _showSnippetCompositeView: function () {
                if (!this.snippetCompositeView) {
                    this._setSnippetCompositeView();
                }

                if (_.isUndefined(this.snippetCompositeView.isClosed) || this.snippetCompositeView.isClosed) {
                    LEConnection.vent.trigger("KPsTabController::showRegion:recentRegion", {view: this.snippetCompositeView});
                }
            },

            _setSnippetCompositeView: function () {
                var kpsSnippetsCompositeModel = new KPsSnippetsCompositeModel({
                    listTitle: LE.translator.translate("LEConnection.recentSnippet")
                });
                this.snippetCompositeView = new KPsSnippetsCompositeView({
                    model: kpsSnippetsCompositeModel,
                    collection: this._getRecentSnippetsCollection(),
                    type: this.referrerAction
                });

            },

            _showRecent: function () {
                if (this.recentSnippetsCollection && this.recentSnippetsCollection.length > 0) {
                    this._showSnippetCompositeView();
                }
                else {
                    this._hideSnippetCompositeView();
                }
            },

            _hideSnippetCompositeView: function () {
                LEConnection.vent.trigger("KPsTabController::closeRegion:recentRegion");
            },

            findSlugInCollection: function (slug) {
                var returnedModel;

                if (this.recentSnippetsCollection) {
                    returnedModel = this.recentSnippetsCollection.findWhere({slug: slug});
                }

                return returnedModel;
            },

            _reRenderViewIfNeeded: function () {
                if (this.recentSnippetsCollection.length > 1) {
                    this.snippetCompositeView.render();
                }
            },

            _isAuthenticatedUser: function () {
                return this.connectionPanelContextModel.get("userId");
            },

            _setSelected: function (selectedKP) {
                if (this.snippetCompositeView) {
                    if (selectedKP) {
                        var referrerAction = this.connectionPanelContextModel.get("referrerAction");
                        if (_.indexOf(this.referrerActionsArr, referrerAction) > -1) {
                            var slug = selectedKP.get("slug");
                            this.snippetCompositeView.setSelected(slug);
                        }
                        else {
                            this.snippetCompositeView.unSelectAll();
                        }
                    }
                    else {
                        this.snippetCompositeView.unSelectAll();
                    }
                }
            },

            _onSelectedKPChange: function (selectedKP) {
                var slug;
                if (this.snippetCompositeView) {
                    if (selectedKP && this.referrerAction === this.connectionPanelContextModel.get("referrerAction")) {
                        this.selectedKP = selectedKP;
                        this._updateRecentCollection(this.connectionPanelContextModel, selectedKP);
                        slug = selectedKP.get("slug");
                        this.snippetCompositeView.setSelected(slug);
                    }
                    else {
                        this.snippetCompositeView.unSelectAll();
                    }
                }
            },

            _onSnippetFetchSuccess: function (model) {
                LEConnection.logger.debug("RecentSnippetsController:_setupRecent - success");
                this._getRecentSnippetsCollection().add(model);
                this._setSnippetCompositeView();
                this._showSnippetCompositeView();
                this._reRenderViewIfNeeded();
                this._setSelected(model);

            },

            _onSnippetFetchError: function () {
                LEConnection.logger.debug("KPsSearchController:_setupRecent - Failed to fetch data");
            },

            _performFetchWithAuth: function () {
                this._getRecentSnippetsCollection().fetch({
                    lang: this.connectionPanelContextModel.get("locale"),
                    userId: this.connectionPanelContextModel.get("userId"),
                    accountId: this.connectionPanelContextModel.get("accountId"),
                    success: _.bind(this._onSuccess, this),
                    error: _.bind(this._onError, this)
                });
            },

            performFetchWithoutAuth: function () {
                if (this.selectedKP) {
                    var slug = this.selectedKP.get("slug");
                    this.selectedKP.fetch({
                        slug: slug,
                        lang: this.connectionPanelContextModel.get("locale"),
                        success: _.bind(this._onSnippetFetchSuccess, this),
                        error: _.bind(this._onSnippetFetchError, this)
                    });
                }
            }
        });
    });
    return RecentSnippetsController;
});

